import { z } from 'zod';
import { bindWebAuthnGuard } from '../interactions.js';
import { VerificationType } from './verification-type.js';
export const webAuthnVerificationRecordDataGuard = z.object({
    id: z.string(),
    type: z.literal(VerificationType.WebAuthn),
    userId: z.string(),
    verified: z.boolean(),
    registrationChallenge: z.string().optional(),
    authenticationChallenge: z.string().optional(),
    registrationInfo: bindWebAuthnGuard.optional(),
});
